window.filterSettingsAll = {
  category: ['product_line_fashion', 'product_line_fitness'],
  other: ['wishlist'],
};

window.wbShopFilter.enableDisplayActiveFilters();
window.wbShopFilter.setIgnoredFiltersFromActiveFilters(['wishlist']);
window.wbShopFilter.initCategoryFilter(window.filterSettingsAll.category);

$(document).ready( function(){

  var $p_filter = $('.wb-shop-filter-desktop');
  var $p_filter_checkboxes_category = $p_filter.find('.wb-shop-filter__checkbox-category');
  var $p_filter_checkboxes_other = $p_filter.find('.wb-shop-filter__checkbox-other');
  var $p_filter_list = document.querySelector('.wb-shop-filter-desktop__list');

  $p_filter_checkboxes_category.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, $p_filter_checkboxes_category, window.filterSettingsAll.category));
  });  
  $p_filter_checkboxes_other.each(function (index, checkbox) {
    $(checkbox).on('click', window.wbShopFilter.handleCheckboxClick.bind(checkbox, $p_filter_checkboxes_other, window.filterSettingsAll.other));
  });  

  window.wbShopFilter.initMainFilterClass();
});